<template>
  <v-layout row>
    <v-card class="pa-3" style="width: 100%;">
      <form>
        <v-menu
          ref="menu"
          v-model="menu"
          :close-on-content-click="false"
          :nudge-right="40"
          :return-value.sync="dateOfReview"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          min-width="200px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="dateOfReview"
              label="Date of Review"
              prepend-icon="event"
              readonly
              v-on="on"
              style="max-width: 300px;"
            ></v-text-field>
          </template>
          <v-date-picker v-model="dateOfReview" no-title scrollable>
            <v-spacer></v-spacer>
            <v-btn flat color="primary" @click="menu = false">Cancel</v-btn>
            <v-btn flat color="primary" @click="$refs.menu.save(dateOfReview)">OK</v-btn>
          </v-date-picker>
        </v-menu>
        <v-select
          :items="reviewType"
          item-text="name"
          label="Review Type"
          return-object
          solo
          style="max-width: 300px;"
          v-model="selectedReviewType"
        ></v-select>
        <v-textarea
          v-model="newReview"
          label="Review"
          required
          class="mb-2"
        ></v-textarea>
        <Uploader accept="image/jpeg,image/gif,image/png,application/pdf,image/x-eps" @presigned="uploadData = $event" :key="uploaderKey" :maxMB="15">
        </Uploader>
        <v-btn @click="clear">clear</v-btn>
        <v-btn @click="submit" :disabled="presignedPending" :loading="presignedPending">submit</v-btn>
      </form>
      <v-flex mt-4>
        <template>
          <v-data-table
            :headers="headers"
            :items="reviews"
            class="elevation-1"
            :sort-by="['dateOfReview']"
            :sort-desc="[false]"
          >
            <template v-slot:items="props">
              <td>{{ props.item.authorName }}</td>
              <td>{{ props.item.dateOfReview | moment("MM/DD/YY") }}</td>
              <td>{{ props.item.reviewType }}</td>

              <td><v-btn @click="setDialogContentTo(props.item)">View Details</v-btn></td>
            </template>
          </v-data-table>
          <template>
            <v-dialog v-if="dialogContent" v-model="dialog" max-width="800px">
              <v-card>
                <v-card-title>
                  <span class="headline">Review for {{ dialogContent.recipientName }}</span>
                </v-card-title>

                <v-card-text>
                  <p><strong>Author:</strong> {{ dialogContent.authorName }}</p>
                  <p><strong>Date:</strong> {{ dialogContent.dateOfReview | moment("MM/DD/YY") }}</p>
                  <p><strong>Type:</strong> {{ dialogContent.reviewType }}</p>
                  <p><strong>Review:</strong> 
                    <br />
                    {{ dialogContent.review }}
                  </p>
                  <p v-if="dialogContent.uploadUrl"><strong>Related File:</strong>
                    <br />
                    <a v-bind:href="dialogContent.uploadUrl" target="_blank">
                      <strong>Download ({{ dialogContent.uploadFilename }})</strong>
                    </a>
                  </p>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn text @click="close">Close</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </template>
        </template>
      </v-flex>
    </v-card>
  </v-layout>
</template>

<script>
import { mapState } from 'vuex'
import ApiField from '@/components/base/api-field.vue'
import EmployeeSelect from '@/components/hr/employee-select.vue'
import EmployeeField from '@/components/hr/employee-field.vue'
import EmployeeDateField from '@/components/hr/employee-date-field.vue'
import EmployeeCheckboxField from '@/components/hr/employee-checkbox-field.vue'
import Uploader from '@/components/hr/uploader.vue'

export default {
  components: {
    EmployeeSelect,
    EmployeeField,
    EmployeeDateField,
    EmployeeCheckboxField,
    Uploader
  },
  computed: {
    ...mapState('userAuth', [
      'user',
    ]),
    ...mapState('employees', [
      'reviews',
    ]),
    presignedPending: function() {
      if (this.uploadData && !this.uploadData.id) {
        return true;
      }
      return false
    },
    presignedPresent: function() {
      if (this.uploadData && this.uploadData.id) {
        return true
      } else {
        return false
      }
    },
    chosenFilename: function() {
      return this.$store.state.uploader.fileName
    },
  },
  props: [
    'employee'
  ],
  created () {
    this.setUp()
  },
  data: function () {
    return {
      dateOfReview: this.$moment().format('YYYY-MM-DD'),
      dialog: false,
      dialogContent: null,
      headers: [
        {
          text: 'Author',
          align: 'left',
          sortable: false,
          value: 'authorName'
        },
        { text: 'Date', value: 'dateOfReview' },
        { text: 'Type', value: 'reviewType' },
        { text: 'Review', value: 'review' }
      ],
      menu: false,
      newReview: '',
      reviewContent: null,
      reviewType: [
        { 
          name: '30 Shift',
          value: '30 Shift Review',
        },
        { 
          name: 'Annual',
          value: 'Annual Review',
        },
        { 
          name: 'Write Up' ,
          value: 'Write Up',
        },
        {
          name: 'Performance Improvement Plan',
          value: 'Performance Improvement Plan'
        },
        {
          name: 'Incident',
          value: 'Incident'
        }
      ],
      selectedReviewType: null,
      uploadData: null,
      uploaderKey: 0
    }
  },
  watch: {
    'selectedReviewType': {
      handler(value) {
        if (value) {
          this.selectedReviewType = value
        } else {
          this.selectedReviewType = null
        }
      }
    },
    dialog (val) {
      val || this.close()
    },
  },
  methods: {
    setDialogContentTo(reviewContent) {
      this.dialogContent = reviewContent
      this.dialog = true
    },
    close () {
      this.dialog = false
    },
    setUp () {
      this.$store.dispatch('employees/getReviews', { recipientId: this.employee.id })
      .then( reviews => {
        //this.reviews = reviews
      },
      error => {
        console.log(error)
      })
    },
    clear () {
      this.selectedReviewType = null,
      this.newReview = '',
      this.uploadData = null,
      this.uploaderKey += 1
    },
    submit () {
      this.$store.dispatch('employees/createReview', {
        recipientId: this.employee.id,
        authorId: this.user.id,
        dateOfReview: this.dateOfReview,
        review: this.newReview,
        reviewType: this.selectedReviewType.value,
        uploadData: this.uploadData,
      }).finally(res => {
        this.$store.commit('uploader/setFilename', '')
        this.clear()
      })
    },
  }
}
</script>
